import { connect } from 'react-redux';
import { change, Field } from 'redux-form';
import { useState } from 'react';
import { useValidation } from '@eti/providers';
import { analytics } from '@eti/utils';
import { ProductCardModalType } from '../../../models/product';
import { useProductCardContext } from '../../../context/ProductCardContext';
import { formatGet, formatSet } from '../../../../single-choice/utils/format';
import ProductModal from '../../../components/ProductModal';
import { getButtonOptions } from '../../../utils/productCardProps';
import { ELEMENT_PLACEMENT } from '../../../utils/productGATrackingUtil';
import SingleChoiceAddToCart from './SingleChoiceAddToCart';
import SingleChoiceToggleBar from './SingleChoiceToggleBar';
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
function isTravelerNew(sellSpecification) {
  return sellSpecification.__typename === 'SellSpecificationTravelerNew';
}
const SingleChoiceOptions = {
  Decline: 0,
  Confirm: 1
};
const SingleChoiceField = ({
  dispatch,
  onChange
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const {
    priceRaw,
    extraProps,
    productCardModal,
    title,
    form = '',
    productName,
    sellSpecification,
    modalText,
    shouldDisableValidation,
    shouldEnableAddToCartButton,
    sendCartGAEvent
  } = useProductCardContext();
  const {
    labelNo,
    labelYes,
    onButtonChange,
    normalize,
    selectOneLabel
  } = extraProps;
  const validate = useValidation(productName);
  analytics.useLogMouseFlowTagEffect('steering validation', shouldDisableValidation);
  const SingleChoiceButton = shouldEnableAddToCartButton ? SingleChoiceAddToCart : SingleChoiceToggleBar;
  const buttonOptions = getButtonOptions(productName, labelYes, labelNo);
  const fieldsetLegend = shouldDisableValidation ? '' : selectOneLabel;
  const hasModal = Boolean(productCardModal && productCardModal.type !== ProductCardModalType.None && productCardModal.content);
  const handleChange = e => {
    var _e$target;
    const value = typeof e === 'string' ? e : e === null || e === void 0 || (_e$target = e.target) === null || _e$target === void 0 ? void 0 : _e$target.value;
    if (onButtonChange) {
      onButtonChange(value);
    }
    if (onChange && value) {
      onChange(value);
    }
    if (sendCartGAEvent && value) {
      sendCartGAEvent(value);
    }
    if (sellSpecification && isTravelerNew(sellSpecification)) {
      const travelerIds = sellSpecification.sellPriceTravelers.flatMap(t => t ? t.travelerId : []);
      dispatch(change(form, productName, {
        travelerIds
      }));
    }
    if (hasModal) {
      const openModalOnAccept = (productCardModal === null || productCardModal === void 0 ? void 0 : productCardModal.type) === ProductCardModalType.Confirmation && value === 'true';
      const openModalOnDecline = (productCardModal === null || productCardModal === void 0 ? void 0 : productCardModal.type) === ProductCardModalType.Persuasion && value === 'false';
      setIsOpen(openModalOnAccept || openModalOnDecline);
    }
  };
  const modalAction = option => {
    const {
      value
    } = buttonOptions[option];
    dispatch(change(form, `${productName}.value`, {
      value,
      priceRaw
    }));
    setIsOpen(false);
    if (sendCartGAEvent) {
      sendCartGAEvent(value, {
        elementPlacement: ELEMENT_PLACEMENT.POP_UP
      });
    }

    // Move focus to appropriate button on modal closed
    const productRadioButton = document.querySelector(`#${productName}_${value}`);
    if (productRadioButton) {
      setTimeout(() => {
        productRadioButton.focus();
      }, 400);
    }
  };
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Field, {
      className: "singleChoice",
      component: SingleChoiceButton,
      form: form,
      format: formatGet,
      legend: fieldsetLegend,
      name: `${productName}.value`,
      normalize: normalize || formatSet(priceRaw),
      onChange: handleChange,
      options: buttonOptions,
      priceRaw: priceRaw,
      validate: shouldDisableValidation || shouldEnableAddToCartButton ? undefined : validate
    }), hasModal && /*#__PURE__*/_jsx(ProductModal, {
      confirmText: modalText === null || modalText === void 0 ? void 0 : modalText.confirmText,
      content: productCardModal === null || productCardModal === void 0 ? void 0 : productCardModal.content,
      declineText: modalText === null || modalText === void 0 ? void 0 : modalText.declineText,
      isOpen: isOpen,
      onConfirm: () => modalAction(SingleChoiceOptions.Confirm),
      onDecline: () => modalAction(SingleChoiceOptions.Decline),
      productName: productName,
      title: title
    })]
  });
};
const mapDispatchToProps = dispatch => ({
  dispatch
});
export default connect(null, mapDispatchToProps)(SingleChoiceField);
//# sourceMappingURL=SingleChoiceField.js.map